export default __webpack_public_path__ + "static/media/5.3ccc593e.jpg";